"use strict";
import _ from 'lodash';

/*
* Dos opciones para implementar la funcionalidad del grid
* http://vitalets.github.io/angular-xeditable/#editable-row
* http://softwarejuancarlos.com/2014/09/09/angularjs-crud-grid/
*
* De momento elijo la primera porque es la más sencilla al basarse en una libería que parece tener bastante actividad
* */

export default class EditInscriptionsController
{
	/*@ngInject*/
	constructor($http, $stateParams, $state, Modal)
	{
		this.$http = $http;
		this.Modal = Modal;

		if (!$stateParams.id)
			return $state.go("home");

		$http.post("/api/backend/events/inscriptions/" + $stateParams.id)
		.then(response =>
		{
			this.race = response.data.race;
			this.category = response.data.category;
			this.users = response.data.inscriptions;
		});
	}

	ConfirmedChanged(user)
	{
		this.$http.post("/api/backend/events/updateinscription/" + user.id, {field: "confirmed", value: user.confirmed });
	}

	CheckTransponder(transponder, user)
	{
		if (transponder === "") transponder = null;
		if (transponder)
		{
			var i = parseInt(transponder, 10);
			if (_.isInteger(i) === false || i < 1000000 || i > 9999999)
				return "El transponder debe ser un número de 7 cifras";
		}
		
		this.$http.post("/api/backend/events/updateinscription/" + user.id, {field: "transponder", value: transponder });
	};

	CheckRank(rank, user)
	{
		//console.log(rank);
		//console.log(user);

		if (rank === "") rank = null;
		if (rank)
		{
			var i = parseInt(rank, 10);
			if (i <= 0 || i > 999)
				return "El rank debe ser un número entero positivo";
		}
		
		this.$http.post("/api/backend/events/updateinscription/" + user.id, { field: "rank", value: rank });
	};

	// remove user
	RemoveUser(index, user) 
	{
		this.Modal.confirm.delete((/*Option params are passed here*/) => {
			this.$http.post("/api/backend/events/removeinscription/" + user.id)
			.then(response => {
				// TODO: Mejor buscar por user
				this.users.splice(index, 1);
			});
		})({
			header: 
			`<h3 style="margin-top:0; color:black!important">{{vm.race}}</h3>
			<h4 style='margin-bottom:0; color:white!important'>{{vm.category}}</h4>`,
			html: [
				"<strong>{{vm.user.name}} {{vm.user.surname}}</strong>",
				"{{'EVENT_CancelRegistrationWarning'|translate}}"
			],
			btnAccept: "EVENT_CancelRegistration",
			vm: {race: this.race, category: this.category, user: user}
		}/*Optional params here*/);
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/events/edit_inscriptions.controller.js